import React from 'react';
import Navbar from '../Components/Navbar';
import Hero from '../Components/Hero';
import VehicleShowcase from '../Components/VehicleShowcase';
import Footer from '../Components/Footer';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div style={{ backgroundColor: 'var(--bg-main)', minHeight: '100vh', position: 'relative' }}>
      <Navbar />
      
      <Hero />
      
      <main>
        {/* Vehicles Section */}
        <div style={{ position: 'relative', padding: '120px 0', overflow: 'hidden' }}>
          <div className="ambient-light" style={{ top: '-10%', right: '-10%', opacity: 0.2 }}></div>
          <div className="container">
            <VehicleShowcase />
          </div>
        </div>

        {/* Brand Philosophy Section */}
        <section style={{ padding: '120px 0', position: 'relative' }}>
          <div className="ambient-light ambient-light-silver" style={{ bottom: '-20%', left: '-10%', opacity: 0.1 }}></div>
          <div className="container">
            <div style={{ marginBottom: '60px' }}>
              <motion.h2 
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true }}
                className="section-title"
              >
                Vizyon<span>Felsefesi</span>
              </motion.h2>
            </div>
            
            <div className="grid lg:grid-cols-12 gap-20 items-center">
              <div className="lg:col-span-6" style={{ position: 'relative' }}>
                <div style={{ aspectRatio: '16/10', border: '1px solid var(--card-border)', overflow: 'hidden', boxShadow: 'var(--shadow-md)' }}>
                  <img 
                    src="https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&q=80&w=800" 
                    alt="Car Detail" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.7, transition: 'opacity 1s' }}
                  />
                </div>
                <div style={{ 
                  position: 'absolute', bottom: '-40px', right: '-40px', width: '180px', height: '180px',
                  border: '1px solid var(--card-hover-border)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                  backdropFilter: 'blur(24px)', background: 'var(--bg-card)', zIndex: 20, boxShadow: 'var(--shadow-md)'
                }}>
                  <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '2.5rem', fontWeight: 900, color: 'var(--primary)' }}>10+</div>
                    <div style={{ fontSize: '0.6rem', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--text-muted)' }}>Yıllık Tecrübe</div>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-6">
                <h3 style={{ fontSize: 'clamp(1.5rem, 3vw, 2.5rem)', fontWeight: 900, color: 'var(--text-main)', marginBottom: '24px', letterSpacing: '-0.03em', textTransform: 'uppercase', lineHeight: 0.95 }}>
                  Mükemmellik Bir Seçenek Değil, <span style={{ color: 'var(--primary)', fontStyle: 'italic' }}>Standarttır.</span>
                </h3>
                <p style={{ fontSize: '1.05rem', marginBottom: '36px', fontWeight: 300, lineHeight: 1.8, color: 'var(--text-muted)' }}>
                  Erenis Otomotiv olarak, Kahramanmaraş'ta araç kiralama ve satış standartlarını yeniden tanımlıyoruz. Her aracımız, markamızın taşıdığı prestiji yansıtacak şekilde titizlikle seçilir ve hazırlanır.
                </p>
                <Link to="/hakkimizda" style={{ fontSize: '0.85rem', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--text-main)', borderBottom: '1px solid var(--text-muted)', paddingBottom: '8px', transition: 'all 0.3s' }}>
                  Hikayemizi Keşfedin
                </Link>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section style={{ padding: '160px 0', position: 'relative' }}>
          <div className="ambient-light" style={{ top: '50%', left: '50%', transform: 'translate(-50%,-50%)', opacity: 0.2 }}></div>
          <div className="container" style={{ textAlign: 'center', maxWidth: '900px' }}>
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            >
              <h2 style={{ fontSize: 'clamp(2.5rem, 7vw, 6rem)', fontWeight: 900, marginBottom: '32px', letterSpacing: '-0.05em', textTransform: 'uppercase', color: 'var(--text-main)', lineHeight: 0.9 }}>
                Prestije <span style={{ display: 'block', WebkitTextStroke: '1px var(--section-title-stroke)', color: 'transparent' }}>Hazır Mısınız?</span>
              </h2>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '32px', marginTop: '48px' }}>
                <Link to="/teklif-al" style={{ fontSize: '0.8rem', fontWeight: 700, letterSpacing: '0.3em', textTransform: 'uppercase', color: '#050505', background: 'var(--primary)', padding: '20px 48px', transition: 'all 0.4s' }}>
                  Hemen Başlayın
                </Link>
                <a href="tel:+905321585646" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                  <div style={{ width: '56px', height: '56px', borderRadius: '50%', border: '1px solid var(--card-border)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: 'var(--shadow-sm)' }}>
                    <Phone style={{ color: 'var(--text-main)' }} size={22} />
                  </div>
                  <span style={{ fontSize: '1.1rem', fontWeight: 900, color: 'var(--text-main)', letterSpacing: '-0.02em' }}>+90 532 158 56 46</span>
                </a>
              </div>
            </motion.div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Home;
